import { graphql, useStaticQuery } from "gatsby"

// The newest Instagram posts fetched at build time (see sourceNodes in
// gatsby-node.js). Empty when no token is set.
export const useInstagramPosts = () => {
  const { allInstagramPost } = useStaticQuery(graphql`
    query GetInstagramPosts {
      allInstagramPost(sort: { fields: timestamp, order: DESC }, limit: 6) {
        nodes {
          id
          caption
          mediaType
          permalink
          localImage {
            childImageSharp {
              fluid(maxWidth: 480, quality: 80) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)
  return allInstagramPost.nodes
    .filter(post => post.localImage?.childImageSharp?.fluid)
    .map(post => ({
      ...post,
      image: { fluid: post.localImage.childImageSharp.fluid },
    }))
}
